import { render } from "./FindingSeverityChip.vue?vue&type=template&id=8e096188&scoped=true"
import script from "./FindingSeverityChip.vue?vue&type=script&lang=js"
export * from "./FindingSeverityChip.vue?vue&type=script&lang=js"

import "./FindingSeverityChip.vue?vue&type=style&index=0&id=8e096188&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e096188"]])

export default __exports__